export const frequencyOptions = ['Never', 'Immediate', 'DailyDigest']

export const buildBasePortfolioData = () => ({
  isDefault: false,
  emails: [],
  emailSubject: '',
  frequency: 'DailyDigest',
})



// WEBPACK FOOTER //
// ./src/store/portfolio-data.js